import { Navigate, Outlet, useLocation } from "react-router-dom";
import AppSidebar from "@/components/layout/AppSidebar";
import AppTopbar from "@/components/layout/AppTopbar";
import LoadingScreen from "@/components/LoadingScreen";
import { useAuth } from "@/context/AuthContext";
import { useState } from "react";
import IdleTimer from "@/pages/auth/IdleTimer";

const TITLES = {
  "/app/dashboard": ["Dashboard", "Overview of your account activity"],
  "/app/jobs": ["Jobs", "Track and manage your analysis jobs"],
  "/app/jobs/new": ["New Job", "Submit a new analysis job"],
  "/app/reports": ["Reports & Downloads", "Completed jobs, reports and artefacts"],
  "/app/credits": ["Credits", "Purchase and manage credits"],
  "/app/billing": ["Billing", "Invoices and payment history"],
  "/app/notifications": ["Notifications", "Recent activity on your account"],
  "/app/profile": ["Profile", "Manage your personal information"],
  "/app/settings": ["Settings", "Preferences and security"],
};

export default function AppLayout() {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace state={{ from: pathname }} />;
  // Role guard: only end-users belong here
  if (user.role !== "user") return <Navigate to="/admin/dashboard" replace />;

  const [title, subtitle] =
    Object.entries(TITLES).find(([k]) => pathname.startsWith(k))?.[1] ||
    ["Dashboard", ""];

  return (
    <div className="min-h-screen bg-[#F8FAF7]">
      <IdleTimer />
      <AppSidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      <div className="min-h-screen flex flex-col lg:ml-64">
        <AppTopbar
          title={title}
          subtitle={subtitle}
          onMenuClick={() => setSidebarOpen(true)}
        />
        <main className="flex-1 p-4 md:p-6 lg:p-8 fade-in">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
